import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

firebase.initializeApp({
  apiKey: "AIzaSyCuFSszzsC6G5pWXcrVbDJixDzWjXc8Uto",
  authDomain: "harrys-email-capture.firebaseapp.com",
  projectId: "harrys-email-capture",
  appId: "1:926212597192:web:81732782b4a2d9dda04cfd",
  measurementId: "G-PTKBXH9GZ9"
});

export const db = firebase.firestore();
export const analytics = firebase.analytics();
